import VueTypes, { nullable } from 'vue-types';
import { BadgeItem } from '~/themes/novaporta/types/badges';
import { ServiceItem } from '~/themes/novaporta/types/product';

// MODEL: PocketProductItem
export const PocketProductItem = VueTypes.shape({
    id: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
    img: VueTypes.oneOfType([String, nullable]).def(null),
    slug: VueTypes.string.isRequired
}).isRequired;

// MODEL: TabItem
export const TabItem = VueTypes.shape({
    title: VueTypes.string.isRequired,
    keyword: VueTypes.string.isRequired
}).isRequired;

// MODEL: CharacteristicsItem
export const CharacteristicsItem = VueTypes.shape({
    name: VueTypes.string.isRequired,
    value: VueTypes.string.isRequired
}).isRequired;

// MODEL: InfoCardItem
export const InfoCardItem = VueTypes.shape({
    title: VueTypes.string.isRequired,
    content: VueTypes.oneOfType([String, nullable]).isRequired,
    icon: VueTypes.string.isRequired
}).isRequired;

// MODEL: SliderItem
export const SliderItem = VueTypes.shape({
    id: VueTypes.number.isRequired,
    img: VueTypes.string.isRequired
}).isRequired;

// MODEL: ParameterValueItem
export const ParameterValueItem = VueTypes.shape({
    id: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
    slug: VueTypes.string.isRequired,
    active: VueTypes.bool.isRequired,

    img: VueTypes.oneOfType([String, nullable]).def(null)
}).isRequired;

// MODEL: ParameterItem
export const ParameterItem = VueTypes.shape({
    id: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
    description_content: VueTypes.oneOfType([String, nullable]).def(null),
    values: VueTypes.arrayOf(ParameterValueItem).def([])
}).isRequired;

// MODEL: ExtensionValueItem
export const ExtensionValueItem = VueTypes.shape({
    id: VueTypes.oneOfType([Number, nullable]).def(null),
    name: VueTypes.string.isRequired,
    product_id: VueTypes.oneOfType([Number, nullable]).def(null),
    extension_id: VueTypes.oneOfType([Number, nullable]).def(null),
    price: VueTypes.oneOfType([Number, nullable]).def(null),
    multiplicity: VueTypes.oneOfType([Number, nullable]).def(null),
    keyword: VueTypes.oneOfType([String, nullable]).def(null)
}).isRequired;

// MODEL: ExtensionItem
export const ExtensionItem = VueTypes.shape({
    id: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
    description: VueTypes.oneOfType([String, nullable]).def(null),
    type: VueTypes.string.isRequired,
    values: VueTypes.arrayOf(ExtensionValueItem).def([])
}).isRequired;

// MODEL: Product
export const Product = VueTypes.shape({
    id: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
    price: VueTypes.number.isRequired,
    slug: VueTypes.string.isRequired,

    badges: VueTypes.arrayOf(BadgeItem).def([]),
    slides: VueTypes.arrayOf(SliderItem).def([]),
    demo_parameters: VueTypes.arrayOf(ParameterItem).def([]),
    select_parameters: VueTypes.arrayOf(ParameterItem).def([]),
    extensions: VueTypes.arrayOf(ExtensionItem).def([]),
    services: VueTypes.arrayOf(ServiceItem).def([]),

    isOnSale: VueTypes.bool.def(false),
    img: VueTypes.oneOfType([String, nullable]).def(null),
    oldPrice: VueTypes.oneOfType([Number, nullable]).def(null)
}).isRequired;

export const createInfoCardItem = ({ title, content, icon }) => {
    return {
        title: title,
        content: content,
        icon: icon
    };
};

export const createTabItem = ({ title, keyword }) => {
    return {
        title: title,
        keyword: keyword
    };
};

export const createCharacteristicsItem = ({ name, value }) => {
    return {
        name: name,
        value: value
    };
};

export const createSliderItem = ({ id, img }) => {
    return {
        id: id,
        img: img
    };
};

export const createParameterValueItem = ({ id, name, active, slug, img }) => {
    return {
        id: id,
        name: name,
        slug: slug,
        active: active,

        img: img
    };
};

export const createParameterItem = ({ id, name, description_content, values }) => {
    return {
        id: id,
        name: name,
        description_content: description_content,
        values: values
    };
};

export const createExtensionItem = ({ id, name, description, type, values }) => {
    return {
        id: id,
        name: name,
        description: description,
        type: type,
        values: values
    };
};

export const createExtensionValueItem = ({ id, name, product_id, price, multiplicity, keyword, extension_id }) => {
    return {
        id: id,
        name: name,
        product_id: product_id,
        extension_id: extension_id,
        price: price,
        multiplicity: multiplicity,
        keyword: keyword
    };
};

export const createPocketProductItem = ({ id, name, img, slug }) => {
    return {
        id: id,
        name: name,
        img: img,
        slug: slug
    };
};

export const createProduct = ({
    available,
    active,
    id,
    name,
    code,
    price,
    slug,
    badges,
    slides,
    demo_parameters,
    select_parameters,
    services,
    isOnSale,
    img,
    oldPrice,
    extensions,
    short_description = null
}) => {
    return {
        active,
        available,
        id: id,
        name: name,
        price: price,
        slug: slug,
        code: code,
        badges: badges,
        slides: slides,
        demo_parameters: demo_parameters,
        select_parameters: select_parameters,
        extensions: extensions,
        services: services,

        isOnSale: isOnSale,
        img: img,
        oldPrice: oldPrice,

        short_description: short_description
    };
};
